import { render, staticRenderFns } from "./evaluacion-identificacion-editar.vue?vue&type=template&id=33ff5355&scoped=true&"
import script from "./evaluacion-identificacion-editar.vue?vue&type=script&lang=js&"
export * from "./evaluacion-identificacion-editar.vue?vue&type=script&lang=js&"
import style0 from "./evaluacion-identificacion-editar.vue?vue&type=style&index=0&id=33ff5355&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33ff5355",
  null
  
)

export default component.exports